import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-extra',
  templateUrl: './tickets-extra.component.html',
  styleUrls: ['./tickets-extra.component.scss'],
  standalone: false,
})
export class TicketsExtraComponent implements OnInit {
  @Input() ticket;

  constructor() {}

  ngOnInit() {}
}
